import PropTypes from 'prop-types';

/**
 * An access level for a given user; each level has a name and a version of the asset
 */
export default PropTypes.shape({
  name: PropTypes.string.isRequired,
  version: PropTypes.string.isRequired,
});
